import React from 'react';

export const sectionCard: React.CSSProperties = {
    border: '1px solid #E6E6E6',
    borderRadius: 8,
    padding: 28,
    background: '#fff',
    lineHeight: '20px',
    fontSize: '16px',
    overflow: 'visible',
};

export const titleLabel: React.CSSProperties = {
    color: '#000',
    fontSize: '20px',
    marginBottom: 6,
    lineHeight: '24px',
    fontFamily: 'CathaySansRg',
};

export const sectionTitle: React.CSSProperties = {
    color: '#4C4C4C',
    fontSize: '16px',
    marginBottom: 6,
    lineHeight: '20px',
    fontFamily: 'CathaySansBd ',
};

export const label: React.CSSProperties = {
    color: '#4C4C4C',
    fontSize: '14px',
    marginBottom: 6,
    lineHeight: '18px',
    fontFamily: 'CathaySansLt',
};

export const value: React.CSSProperties = {
    color: '#000',
    fontSize: '20px',
    lineHeight: '24px',
    marginBottom: 20,
    fontFamily: 'CathaySans_rg',
};

export const ufiLinkStyle: React.CSSProperties = {
    color: '#116F9A',
    fontSize: 20,
    lineHeight: '24px',
    textDecoration: 'none',
    cursor: 'pointer',
};

export const rowGap = 16;
